import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ViewNotesDialogComponent } from './components/view-notes-dialog/view-notes-dialog.component';
import { ViewAttachmentsDialogComponent } from './components/view-attachments-dialog/view-attachments-dialog.component';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ModalsSharedService {

  constructor(private dialog: DialogService, private http: HttpClient) { }

  openNotesDialog(data: string | undefined) {
    return this.dialog
      .open(ViewNotesDialogComponent, {
        data: {
          notes: data,
          visible: true
        },
        styleClass: 'custom-dialog',
        header: `Notes`
      })
  }

  openAttachmentFilesDialog(data: any) {
    return this.dialog
      .open(ViewAttachmentsDialogComponent, {
        data: {
          attachmentFiles: data,
          visible: true
        },
        styleClass: 'custom-dialog',
        header: `Attachments`
      })
  }

}
